import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { Constants } from 'constants/constants'
import { SalesFetchProps } from 'types/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import { fetchBasketHistorical } from 'queries/sales/basket-historical'
import { getGreenfieldLocationFilter } from 'utils/greenfield'

const timeDimensions = Constants.TIME_DIMENSION_HISTORICAL_GF_ARRAY

export function useBasketSales({
    env,
    accessToken,
    location,
    timePeriodIndex = 0,
}: SalesFetchProps & { timePeriodIndex?: number }) {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME

    const filterLocation = getGreenfieldLocationFilter(location || '')

    // Get current dimension based on index (minus 1 because basket starts at yesterday, not today)
    const currentDimension = timeDimensions[timePeriodIndex - 1]

    const query = useQuery({
        queryKey: [
            QueryKeys.BASKET_SALES_HISTORICAL,
            location,
            currentDimension,
        ] as const,
        queryFn: async () =>
            fetchBasketHistorical({
                env,
                accessToken,
                location,
                filters: {
                    ...filterLocation,
                    time_dimension: currentDimension,
                },
                trackEvent,
            }),
        staleTime: tenMinutes,
        cacheTime: tenMinutes,
        retry: false,
        enabled: !!currentDimension, // Only fetch if we have a valid dimension (not today/index 0)
    })

    return query
}
